import { createDecorator } from "../../instantiation/common/registry";

export const IAnalyticsService = createDecorator<IAnalyticsService>("analyticsService");

export interface IAnalyticsService {

    logEvent(eventName: string, params?: { [key: string]: any }): void;

}